import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useOutletContext } from "react-router-dom";
import { classNames } from "../App";

import ProjectEditor from "./ProjectEditor";
import NiceModal from "@ebay/nice-modal-react";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/16/solid";
import { CheckIcon, PencilIcon } from "@heroicons/react/24/outline";
import { useQueryClient } from "@tanstack/react-query";

export const ProjectsSelector = ({
  projects,
  selectedProject,
  setSelectedProject,
  user,
}) => {
  const handleProjectChange = (project) => {
    setSelectedProject(project);
    fetch("/api/admin/last_used_project", {
      method: "PUT",
      body: JSON.stringify({ project_id: project.id }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const queryClient = useQueryClient();
  const showProjecEditor = (project) => {
    NiceModal.show(ProjectEditor, {
      queryClient: queryClient,
      project: project,
    });
  };

  return (
    <Listbox>
      <div className="relative mt-2">
        <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-sm/6">
          <span className="col-start-1 row-start-1 truncate pr-6">
            Projekt:{" "}
            <span className="font-semibold">{selectedProject?.name}</span>
          </span>
          <ChevronUpDownIcon
            aria-hidden="true"
            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
          />
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline outline-1 outline-black/5 data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {projects.map((project) => (
            <ListboxOption
              key={project.id}
              value={project}
              onClick={() => handleProjectChange(project)}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-gray-100"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">
                {project?.name}
              </span>

              {user.admin && (
                <span
                  onClick={() => showProjecEditor(project)}
                  className="absolute inset-y-0 right-0 flex text-gray-400 items-center pr-4 hover:text-gray-800"
                >
                  <PencilIcon
                    aria-hidden="true"
                    className="size-3 hover:size-4"
                  />
                </span>
              )}
            </ListboxOption>
          ))}
          {user.admin && (
            <ListboxOption
              key="add_new_project"
              onClick={() => showProjecEditor(null)}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-gray-100 hover:bg-gray-50"
            >
              <span className="block truncate font-normal">+ Neu</span>
            </ListboxOption>
          )}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};
/*return (
    <Menu as="div" className="relative inline-block">
      <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
        Projekt: {selectedProject?.name}
        <ChevronDownIcon
          aria-hidden="true"
          className="-mr-1 size-5 text-gray-400"
        />
      </MenuButton>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg outline outline-1 outline-black/5 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-1">
          {projects.map((project) => (
            <MenuItem
              key={project.id}
              onClick={() => handleProjectChange(project)}
            >
              <a
                href="#"
                className={classNames(
                  project.id == selectedProject?.id ? "font-semibold" : "",
                  "block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                )}
              >
                {project.name}
              </a>
            </MenuItem>
          ))}
          {user.admin && (
            <MenuItem>
              <a
                onClick={handleAddProject}
                href="#"
                className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
              >
                Neues Projekt erstellen
              </a>
            </MenuItem>
          )}
        </div>
      </MenuItems>
    </Menu>
  );
};*/
